document.addEventListener('DOMContentLoaded', function() {
    // Check if we are on the target product page or home page
    if (window.location.pathname === '/products/ultimate-multivitamin-for-women-men-50' || window.location.pathname === '/') {
        
        // Function to wrap specific text content with a span
        function wrapTextContent(node, searchText, className) {
            const regex = new RegExp(`\\b${searchText}\\b`, 'g');
            if (node.nodeType === Node.TEXT_NODE && regex.test(node.textContent)) {
                const span = document.createElement('span');
                span.className = className;
                span.textContent = searchText;
                const parts = node.textContent.split(searchText);
                node.parentNode.insertBefore(document.createTextNode(parts[0]), node);
                node.parentNode.insertBefore(span, node);
                node.textContent = parts.slice(1).join(searchText);
            }
        }

        // Traverse all elements and apply the wrap function only to text nodes
        document.querySelectorAll('*:not(script):not(style)').forEach(element => {
            Array.from(element.childNodes).forEach(child => {
                wrapTextContent(child, 'beJOYLY', 'highlighted-bejoyly');
            });
        });

        // Function to check the background color of an element
        function getBackgroundColor(element) {
            let backgroundColor;
            while (element && element !== document) {
                backgroundColor = window.getComputedStyle(element).backgroundColor;
                if (backgroundColor && backgroundColor !== 'rgba(0, 0, 0, 0)' && backgroundColor !== 'transparent') {
                    break;
                }
                element = element.parentElement;
            }
            return backgroundColor;
        }

        // Adjust color if the background is #99CAE9
        document.querySelectorAll('.highlighted-bejoyly').forEach(span => {
            const backgroundColor = getBackgroundColor(span);
            if (backgroundColor === 'rgb(153, 202, 233)') {  // rgb equivalent of #99CAE9
                span.style.color = '#FFFFFF';  // Switch text color to white
            } else {
                span.style.color = '#99CAE9';  // Default text color
            }
        });
    }
});


document.addEventListener('DOMContentLoaded', function() {
    const faqItems = document.querySelectorAll('.faq_section .faq__item');

    faqItems.forEach(item => {
        const questionButton = item.querySelector('.faq__item__question');
        const answerContent = item.querySelector('.faq__item-content');

        questionButton.addEventListener('click', function() {
            // Close all other FAQ items
            faqItems.forEach(i => {
                i.querySelector('.faq__item-content').style.maxHeight = '0';
                i.querySelector('.faq__item-content').style.display = 'none';
            });

            // Toggle current FAQ item
            const isOpen = answerContent.style.display === 'block';
            answerContent.style.maxHeight = isOpen ? '0' : answerContent.scrollHeight + 'px';
            answerContent.style.display = isOpen ? 'none' : 'block';
        });
    });
});


document.addEventListener("DOMContentLoaded", function() {
  const productImages = document.querySelector(".product__images");

  if (!productImages) return;

  // Function to handle scroll on desktop only
  function handleProductImageScroll() {
    // Remove any previously added scroll event listener to prevent duplicates
    window.removeEventListener("scroll", scrollEffect);

    // Check if screen width is desktop size (e.g., greater than 768px)
    if (window.innerWidth > 768) {
      window.addEventListener("scroll", scrollEffect);
    } else {
      // Ensure that scrolling effect is removed on mobile
      productImages.classList.remove("is-scrolling");
    }
  }

  // Define the scroll effect logic
  function scrollEffect() {
    const productImagesOffset = productImages.offsetTop;
    const footer = document.querySelector(".footer");
    const footerOffset = footer ? footer.offsetTop : document.body.scrollHeight;

    const scrollPosition = window.scrollY + window.innerHeight;

    if (scrollPosition > productImagesOffset && scrollPosition < footerOffset) {
      productImages.classList.add("is-scrolling");
    } else {
      productImages.classList.remove("is-scrolling");
    }
  }

  // Initialize the function on page load
  handleProductImageScroll();

  // Re-apply on window resize
  window.addEventListener("resize", handleProductImageScroll);
});





